export default __webpack_public_path__ + "static/media/iPhone-Premium-4.afe74f28.png";